import jsonFromDom from "./jsonFromDom";
import { trackEvent } from "./track";
import links from "./links";
import { escapeQuotes } from "./helpers/stringHelpers";
import getLinkText from "./helpers/getLinkText";
import getPageName from "./helpers/track/getPageName";
import isProductDetail from "./helpers/track/isProductDetail";

function leaveSitePrompt(e, target, modals) {
    const link = target.getAttribute("href");
    const fileName = link.split("/").pop();
    const fileFormat = fileName.split(".").pop();
    const isPdf = fileFormat?.toLowerCase() === "pdf";
    const modal = getModalWithBlacklistedUrl(modals, link);
    if (modal) {
        e.preventDefault();
        // Trigger Modal Dispatch
        window.dispatchEvent(new CustomEvent("open-modal", { detail: { id: modal.getAttribute("data-id") } }));
        // Set Proceed Button URL
        setProceedUrl(link, modal, target);
        if (isPdf || target.dataset.linktype == "download" || target.hasAttribute("download")) {
            links.pushExternalDownloadEvent(target);
        }
    } else{
        pushDataLayer(link, target);
        if (isPdf || target.dataset.linktype == "download" || target.hasAttribute("download")) {
            links.pushExternalDownloadEvent(target);
        }
    }
}

function pushDataLayer(link, target) {
    const linkText = getLinkText({ target, link });
    const pageName = getPageName();

    trackEvent({
        event: "outbound_link",
        url: link,
        interaction_type: "outbound_link"
    });
    trackEvent({
        event: "click_outbound_link",
        ...(linkText && {element_text: linkText}),
        element_url: link,
        event_type: "click",
        item_related: isProductDetail() ? pageName : 'none',
    });
}

function getModalWithBlacklistedUrl(modals, href) {
    let modal;
    for (let i = 0; i < modals.length; i++) {
        let json = jsonFromDom(".leaveSitePrompt__data--" + modals[i].getAttribute("data-id"));
        if (json.filterType && isBlacklistedUrl(href, json)) {
            modal = modals[i];
            break;
        }
    }
    return modal;
}

function isBlacklistedUrl(href, json) {
    let isBlackListed;
    switch (json.filterType) {
        case "whitelist":
            isBlackListed = !json.list.find((url) => getUrlDomain(url) === getUrlDomain(href));
            break;
        case "blacklist":
            isBlackListed = json.list.find((url) => getUrlDomain(url) === getUrlDomain(href));
            break;
        default:
            isBlackListed = true;
    }
    return isBlackListed;
}

function getUrlDomain(link) {
    try {
        const url = new URL(link);
        return url.origin;
    } catch(e) {
        return link;
    }
}

function setProceedUrl(link, modal, target) {
    const button = modal.querySelector(".leaveSitePrompt__button");
    button.setAttribute("href", link);
    button.setAttribute("target", "_blank");
    button.dataset.linktype = target.dataset.linktype;
    button.dataset.linktext = escapeQuotes(target.innerText);
    if (target.hasAttribute("download")) {
        button.setAttribute("download", target.getAttribute("download") || "");
    }
}

export { leaveSitePrompt };
